import React from 'react';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { ModalWithStyles } from './ModalWithStyles';
import { Formik } from 'formik';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';

export function DeleteVmModal(props) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (props.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              call: methodNameEnum.DELETE_VM_DROP,
              apikey: props.userAtom.contents?.apikey,
              businessid: props.userAtom.contents?.businessid,
              vmdid: values.selected[i].voicemaildropid,
              userid: props.userAtom.contents.userid,
            };
            await props.mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_VM_DROP,
              payload: data,
            });
          }
          props.handleClose();
        }
        props.setRefetchToggleForVmDrop({});
        props.enqueueSnackbarWithStyles({
          message: 'Successfully Deleted VM Drop(s)',
          alertProps: { severity: 'success' },
        });
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: props.selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Voicmail Drop(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={props.show}
              onHide={props.handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              size="xs"
              deleteDialog={true}
            >
              <p>
                You are about to delete {formik.values.selected.length} VM
                Drop(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
